export default __webpack_public_path__ + "static/media/Hamburger.1ffc8c0d.jpg";